import types from "./subCustomerTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_SUBCUSTOMERS:
			return {
				...state,
				loading: false,
				subCustomers: action.payload
			};
		default:
			return state;
	}
};
